import { useState } from "react";
import { toast } from "sonner";
import { api, formatError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Field, Panel } from "./Fields";

export const AccountTab = () => {
  const { user } = useAuth();
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 10) return toast.error("A nova senha precisa ter pelo menos 10 caracteres.");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: next });
      toast.success("Senha alterada com sucesso");
      setCur("");
      setNext("");
    } catch (err) {
      toast.error(formatError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Panel title="Conta" desc={`Conectado como ${user?.email}`}>
      <form onSubmit={submit} className="max-w-md space-y-5" data-testid="change-password-form">
        <Field type="password" label="Senha atual" value={cur} onChange={setCur} testid="current-password-input" />
        <Field type="password" label="Nova senha (mín. 10 caracteres)" value={next} onChange={setNext} testid="new-password-input" />
        <button type="submit" disabled={busy} className="h-11 px-6 text-xs uppercase tracking-[0.15em] bg-white text-black hover:bg-[#E5CF9F] disabled:opacity-60" data-testid="change-password-submit">
          Alterar senha
        </button>
      </form>
    </Panel>
  );
};
